export default function AnimatedBackground({ children }) {
  return (
    <section className="animated-background bg-gradient-to-r from-blue-500 via-pink-500 to-yellow-500">
      <div className="bg-[url(assets/images/noise.png)]  lg:pl-12">
        {/* <div className="animated-background bg-gradient-to-r from-blue-500 via-pink-500 to-yellow-500 lg:pl-12"> */}
        {children}
        {/* </div> */}
      </div>
    </section>
  );
}
